<div class="form-group mg-t10" *ngIf="SeasonShow">
    <label for="type">{{'WHEEL_CHARACTERISTICS.1' | translate}}<span class="mandatory-asterisk">*</span></label>
    <div class="season-cards-container">
        <div class="season-card" [ngClass]="{'season-card-selected': Season === SeasonType.SUMMER}"
            (click)="setSeason(SeasonType.SUMMER)">
            <img src="assets/icons/summer_icon.svg" alt="" loading="lazy">
            {{'SEASON_TYPE.' + SeasonType.SUMMER | translate}}
        </div>
        <div class="season-card" [ngClass]="{'season-card-selected': Season === SeasonType.WINTER}"
            (click)="setSeason(SeasonType.WINTER)">
            <img src="assets/icons/winter-icon.svg" alt="" loading="lazy">
            {{'SEASON_TYPE.' + SeasonType.WINTER | translate}}
        </div>
        <div class="season-card" [ngClass]="{'season-card-selected': Season === SeasonType.ALL_SEASON}"
            (click)="setSeason(SeasonType.ALL_SEASON)">
            <img src="assets/icons/4-seasons-icon.svg" alt="" loading="lazy">
            {{'SEASON_TYPE.' + SeasonType.ALL_SEASON | translate}}
        </div>
    </div>
</div>

<div *ngIf="TyreReadingTitle" class="label-title mg-t22">
    {{'WHEEL_CHARACTERISTICS.12' | translate}}
</div>

<div class="input-inline-group mg-t15">
    <div class="form-group" style="flex: 1;">
        <label for="Width">{{'WHEEL_CHARACTERISTICS.2' | translate}}<span class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown [dataArray]="WidthArray" [selectedKey]="Width"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setWidth($event)"></app-select-by-keys-dropdown>
    </div>
    <div class="form-group" style="flex: 1;">
        <label for="Series">{{'WHEEL_CHARACTERISTICS.3' | translate}}<span class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown [dataArray]="SeriesArray" [selectedKey]="Series"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setSeries($event)"></app-select-by-keys-dropdown>
    </div>
    <div class="form-group" style="flex: 1;">
        <label for="Radii">{{'WHEEL_CHARACTERISTICS.4' | translate}}<span class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown [dataArray]="DiameterArray" [selectedKey]="Diameter"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setDiameter($event)"></app-select-by-keys-dropdown>
    </div>
</div>

<div class="input-inline-group mg-t15">
    <div class="form-group" style="flex: 1;">
        <label for="SpeedIndex">{{'WHEEL_CHARACTERISTICS.5' | translate}}<span
                class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown [dataArray]="LoadIndexArray" [selectedKey]="LoadIndex" [selectedKey]="LoadIndex"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setLoadIndex($event)"></app-select-by-keys-dropdown>
    </div>
    <div class="form-group" style="flex: 1;">
        <label for="LoadIndex">{{'WHEEL_CHARACTERISTICS.6' | translate}}<span
                class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown [dataArray]="SpeedIndexArray" [selectedKey]="SpeedIndex" [selectedKey]="SpeedIndex"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setSpeedIndex($event)"></app-select-by-keys-dropdown>
    </div>
</div>

<!-- CHECKBOX SECTION -->

<div class="checkbox-section">
    <div class="checbox-container" (click)="changeIsAntiFlat()">
        <input type="checkbox" class="checkbox" id="IsAntiFlat" [checked]="IsAntiFlat" />
        <label>{{'WHEEL_CHARACTERISTICS.7' | translate}}</label>
        <!-- QUITAR FOR DEL LABEL PARA QUE NO INTERFIERA EN EL CAMBIO DE ESTADO -->
    </div>
    <div class="checbox-container" (click)="changeDidWeAlignTyres()">
        <input type="checkbox" class="checkbox" id="DidWeAlignTyres" [checked]="DidWeAlignTyres" />
        <label>{{'WHEEL_CHARACTERISTICS.8' | translate}}</label>
    </div>
    <div class="checbox-container" (click)="changeDidWePermuteTyres()">
        <input type="checkbox" class="checkbox" id="DidWePermuteTyres" [checked]="DidWePermuteTyres" />
        <label>{{'WHEEL_CHARACTERISTICS.9' | translate}}</label>
    </div>

</div>

<div *ngIf="BrandMdelTitle" class="label-title mg-t22">
    {{'WHEEL_CHARACTERISTICS.13' | translate}}
</div>

<div class="form-group mg-t15">
    <label for="Brand">{{'WHEEL_CHARACTERISTICS.10' | translate}}<span class="mandatory-asterisk">*</span>
        <img *ngIf="loadingModels" class="img-loading-models" src="../../../assets/gifs/loading-spinner.gif"
            alt="loading" />
    </label>
    <app-select-by-keys-dropdown [loading]="loadingModels" [otherOption]="true" [dataArray]="BrandArray"
        [selectedKey]="Brand" [selectedKey]="Brand" [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
        (optionEmitter)="setBrand($event)"></app-select-by-keys-dropdown>
</div>


<div class="form-group mg-t15">
    <label for="Model">{{'WHEEL_CHARACTERISTICS.11' | translate}}<span class="mandatory-asterisk">*</span>
        <img *ngIf="loadingModels" class="img-loading-models" src="../../../assets/gifs/loading-spinner.gif"
            alt="loading" />
    </label>
    <app-select-by-keys-dropdown [loading]="loadingModels" [otherOption]="true"
        [dataArray]="BrandModelMap.get(Brand) ? BrandModelMap.get(Brand) : []" [selectedKey]="Model"
        [selectedKey]="Model" [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
        (optionEmitter)="setModel($event)"></app-select-by-keys-dropdown>
</div>

<!-- EXTRA INFO -->

<div class="label-title mg-t22" *ngIf="DotCodeTitle">Información complementaria</div>

<div class="form-group mg-t22">
    <label for="DotCode">DOT (registro código)</label>
    <input id="DotCode" [(ngModel)]="DotCode" (ngModelChange)="setDotCode(DotCode)" class="form-text-input"
        maxlength="4" placeholder="3201" type="text">
</div>